export default __webpack_public_path__ + "static/media/video.2be87151.mp4";